import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export const OAuthCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");
  const email = searchParams.get("email");

  useEffect(() => {
    // Notify the parent window that OAuth completed
    if (window.opener) {
      // Send message to parent window
      window.opener.postMessage({ 
        type: 'oauth-complete', 
        status: status,
        email: email 
      }, '*');
      // Close this popup
      window.close();
    } else {
      // If opened directly (not as popup), redirect to settings
      window.location.href = '/settings?gmail=connected';
    }
  }, [status, email]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="w-16 h-16 bg-emerald-100 rounded-full mx-auto mb-4 flex items-center justify-center">
          <svg className="w-8 h-8 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h2 className="text-xl font-semibold text-slate-800 mb-2">Gmail Connected!</h2>
        <p className="text-slate-500">This window will close automatically...</p>
      </div>
    </div>
  );
};

export default OAuthCallbackPage;
